import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import DataTable from 'components/DxDataTable'
import useLocale from 'hooks/useLocale'
import { useLazyQuery } from 'components/graphql'
import { listBills } from '../../gql'
import { loyaltyCards, bills } from './columns'

const StatisticData = ({ data = [], showUsersCol }) => {
	const [t] = useTranslation()
	const locales = useLocale()

	const [getBill, { data: billsData, loading, called }] = useLazyQuery(listBills, {
		fetchPolicy: 'cache-first'
	})
	const handleRowSelect = rowData => {
		const { cashRegisterId, billNumber } = rowData || {}
		if(cashRegisterId && billNumber) {
			getBill({
				variables: {
					cashRegisterIds: [cashRegisterId],
					numbers: [billNumber]
				}
			})
		}
	}

	return(
		<Row>
			<Col xs={7}>
				<DataTable
					data={data}
					columns={loyaltyCards({ t, locales, showUsersCol })}
					onRowClick={handleRowSelect}
					height={560}
				/>
			</Col>
			<Col xs={5}>
				{called &&
				<DataTable
					data={billsData?.listBills?.items?.[0]?.items || []}
					columns={bills({ t, locales })}
					loading={loading}
				/>
				}
			</Col>
		</Row>
	)
}

export default StatisticData
